


























































import OrderProductWithIngredientsEditPopup from '@/components/ui/popups/takeAway/OrderProductWithIngredientsEditPopup/index.vue';
import DefaultImage from '@/components/ui/product/DefaultImage/index.vue';
import getPopupController from '@/lib/vuePopup';
import { PopupControllerPublicProperties } from '@/lib/vuePopup/interfaces';
import Ingredient from '@/models/ingredient';
import OrderProduct from '@/models/orderProduct';
import OrderProductIngredient from '@/models/orderProductIngredient';
import Place from '@/models/place';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
  name: 'TakeAwayMenuCartPanelProduct',
  components: { DefaultImage },
})
export default class TakeAwayMenuCartPanelProduct extends Vue {
  @Prop({
    type: OrderProduct,
    required: true,
  })
  private product!: OrderProduct;

  private popupController: PopupControllerPublicProperties = getPopupController();

  @State('selectedPlace', {
    namespace: 'place',
  })
  private selectedPlace!: Place;

  private get firstThreeIngredients(): Ingredient[] {
    return this.flattenIngredients.slice(0, 3);
  }

  private get flattenIngredients(): Ingredient[] {
    return this.product.ingredients.reduce(
      (
        ingredients: Ingredient[],
        orderProductIngredient: OrderProductIngredient,
      ): Ingredient[] => {
        for (let count = 0; count < orderProductIngredient.count; count++) {
          ingredients.push(orderProductIngredient.ingredient);
        }

        return ingredients;
      },
      [],
    );
  }

  private get countOfIngredientsOverThree(): number {
    return this.flattenIngredients.length - 3;
  }

  private openOrderProductViewPopup() {
    this.popupController.createPopup(OrderProductWithIngredientsEditPopup, {
      propsData: {
        initOrderProduct: this.product,
      },
    });
  }
}
